import React from 'react'

function PlusCircle ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='16px' height='16px' viewBox='0 0 16 16'>
      <path d='M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C16,3.6,12.4,0,8,0z M8,15.2C4,15.2,0.8,12,0.8,8S4,0.8,8,0.8c4,0,7.2,3.2,7.2,7.2C15.2,12,12,15.2,8,15.2z' />
      <polygon points='8.4,3.8 7.6,3.8 7.6,7.6 3.8,7.6 3.8,8.4 7.6,8.4 7.6,12.2 8.4,12.2 8.4,8.4 12.2,8.4 12.2,7.6 8.4,7.6' />
    </svg>
  )
}

PlusCircle.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default PlusCircle
